// Promise-based confirmation. Call `confirm({...})` anywhere; a single
// <ConfirmHost> (mounted in the app shell) renders the dialog and resolves the
// promise with the user's choice. If no host is mounted it resolves true so
// non-shell contexts (e.g. public pages) don't block.
export interface ConfirmOptions {
  title: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
}

export interface ConfirmRequest extends ConfirmOptions {
  id: number;
  resolve: (ok: boolean) => void;
}

type Listener = (req: ConfirmRequest) => void;
let listener: Listener | null = null;
let counter = 0;

export function confirm(opts: ConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    if (!listener) {
      resolve(true);
      return;
    }
    listener({ id: ++counter, resolve, ...opts });
  });
}

export function setConfirmListener(fn: Listener | null): () => void {
  listener = fn;
  return () => {
    if (listener === fn) listener = null;
  };
}
